import React from "react";
import { Icon, Typography } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import "../../styles/components/choose-number-modal.scss";

// Can be a string as well. Need to ensure each key-value pair ends with ;

class BrandPopup extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: props?.openAuto ? props.openAuto : false,
    };

    this.handleClickOpen = this.handleClickOpen.bind(this);
  }

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = (event, reason) => {
    console.log(reason);
    if (reason && reason === "backdropClick") return;
    this.setState({ open: false });
  };

  render() {
    const { open } = this.state;

    return (
      <div>
        <Dialog
          open={open}
          onClose={this.handleClose}
          aria-labelledby="add-new-number-one-title"
          aria-describedby="add-new-number-one-description"
          classes={{
            root: "add-new-number-modal",
            paper: "paper",
          }}
          BackdropProps={{
            classes: {
              root: "backdrop",
            },
          }}
        >
          <DialogContent>
            <div className="content brand-popup">
              <div className="brand-wrapper">
                <Icon className="close-icon" onClick={this.handleClose}>
                  close
                </Icon>
                <Typography
                  className="main-title"
                  component={"p"}
                  style={{
                    marginLeft: 0,
                    width: "100%",
                    textAlign: "center",
                    verticalAlign: "middle",
                    lineHeight: 1.5,
                    display: "inline-block",
                  }}
                >
                  To continue sending messages, you must register for 10DLC
                  registration process.
                </Typography>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

export default BrandPopup;
